import React from "react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";
import PropTypes from "prop-types";

const HeaderContainer = styled.div`
  display: flex;
`;

const ContentWrap = styled.div`
  background: ${(props) => (props.alternateColor ? "#f0f4fc" : "#FFFFFF")};
  border-top-right-radius: ${(props) => (props.roundTop ? "20px" : "0")};
  border-bottom-right-radius: ${(props) => (props.roundBottom ? "20px" : "0")};
  width: 100%;
`;

const SettingHeader = styled.div`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 125px;
  width: 100%;
  @media (max-width: 900px) {
    height: 70px;
  }
`;

const IconContainer = styled.div`
  background: ${(props) =>
    props.alternateColor
      ? "#000000"
      : "linear-gradient(90deg, #070d2c, #06010d)"};
  border-top-left-radius: ${(props) => (props.roundTop ? "20px" : "0")};
  border-bottom-left-radius: ${(props) => (props.roundBottom ? "20px" : "0")};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: flex-start;
  width: 100px;
  @media (max-width: 900px) {
    width: 40px;
  }
  img {
    height: auto;
    width: 55px;
    margin-top: 34px;

    @media (max-width: 900px) {
      width: 35px;
      margin-top: 18px;
    }
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SettingName = styled.p`
  color: #2b3c4d;
  font-size: 1.25rem;
  font-weight: 600;
  margin-left: 36px;
  @media (max-width: 900px) {
    font-size: 1rem;
    margin-left: 16px;
  }
`;

const SettingCurrent = styled.p`
  color: #516375;
  font-size: 1rem;
  font-weight: 500;
  margin-right: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 900px) {
    display: none;
  }
  span {
    color: #05d141;
    font-size: 2rem;
    margin-left: 20px;
    transition: transform 0.3s ease;
    transform: ${(props) => (props.open ? "rotateZ(180deg)" : "rotateZ(0deg)")};
  }
`;

const SettingContent = styled.div`
  overflow: hidden;
  transition: max-height 1s cubic-bezier(0, 1, 0, 1);
  ${(props) => props.open && "transition: max-height .8s ease-in-out;"}
  max-height: ${(props) => (props.open ? "1300px" : "0px")};
`;

const Description = styled.h6`
  color: #516375;
  font-size: 1.125rem;
  font-weight: 400;
  margin-bottom: 15px;
  @media (max-width: 900px) {
    font-size: .8rem !important;
  }
`;

const ChildrenContainer = styled.div`
  padding: 0px 36px 36px 36px;

  p {
    color: #516375;
    font-size: 1.125rem;
    margin-bottom: 14px;
    @media (max-width: 900px) {
      font-size: .8rem;
    }
  }

  h5 {
    font-size: 1.25rem;
    @media (max-width: 900px) {
      font-size: .9rem;
    }
  }

  @media (max-width: 900px) {
    padding: 0px 16px 16px 16px;
  }
`;

export const Accordion = (props) => {
  return (
    <HeaderContainer>
      <IconContainer
        roundTop={props.roundTop}
        roundBottom={props.roundBottom}
        alternateColor={props.alternateColor}
      >
        <img src={props.icon} alt="setting-icon" />
      </IconContainer>
      <ContentWrap
        roundTop={props.roundTop}
        roundBottom={props.roundBottom}
        alternateColor={props.alternateColor}
      >
        <SettingHeader
          onClick={() => {
            props.setShow(!props.show);
          }}
        >
          <HeaderContent>
            <SettingName>{props.settingName}</SettingName>
            <SettingCurrent open={props.show}>
              {props.currentSetting} <Icon>keyboard_arrow_down</Icon>
            </SettingCurrent>
          </HeaderContent>
        </SettingHeader>
        <SettingContent open={props.show}>
          <ChildrenContainer>
            <Description>{props.description}</Description>
            {props.children}
          </ChildrenContainer>
        </SettingContent>
      </ContentWrap>
    </HeaderContainer>
  );
};

Accordion.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  alternateColor: PropTypes.bool,
  roundTop: PropTypes.bool,
  roundBottom: PropTypes.bool,
  settingName: PropTypes.string,
  currentSetting: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.element.isRequired,
};
